import { createContext, useContext, useState } from "react";

// Create the context
const LoadingContext = createContext({
  isLoading: false,
  setLoading: (loading: boolean) => {}
});

export const LoadingProvider = ({ children }:any) => {
  // Put here the initial state of the loading. Should be true when production. Set to false for development if usefull.
  const [isLoading, setLoading] = useState(true);

  // Value to be passed to the context
  const value = { isLoading, setLoading };

  return (
    <LoadingContext.Provider value={value}>
      {children}
    </LoadingContext.Provider>
  );
};


export const useGlobalLoading = () => useContext(LoadingContext);
